import { Person } from '@ninety/platform/models/_shared/person';

export const initialCurrentPersonState: Person = null;
